import CommonUtils from '@/utils/common-utils';
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: () => import('@/views/pages/Index.vue'),
    children: [
      {
        path: '/',
        component: () => import('@/components/welcome/Welcome.vue'),
        alias: [
          '/welcome',
          '/welcome.html'
        ],
        meta: {
          title: 'Planbook - The Leader in Lesson Planning'
        }
      },
      {
        path: '/teachers',
        component: () => import('@/components/teacher/Teacher.vue'),
        alias: [
          '/teacher'
        ],
        meta: {
          title: 'Teachers - Planbook Lesson Planning Software'
        }
      },
      {
        path: '/schools',
        component: () => import('@/components/school/School.vue'),
        alias: [
          '/school'
        ],
        meta: {
          title: 'Schools - Planbook Educational Planning Platform'
        }
      },
      {
        path: '/pricing',
        component: () => import('@/components/price/Price.vue'),
        alias: [
          '/price'
        ],
        meta: {
          title: 'Pricing - Planbook Subscription Plans'
        }
      },
      {
        path: '/mobile-apps',
        component: () => import('@/components/mobile/Mobile.vue'),
        alias: [
          '/mobile'
        ],
        meta: {
          title: 'Mobile Apps - Planbook on iOS and Android'
        }
      },
      {
        path: '/help',
        component: () => import('@/components/help/Help.vue'),
        meta: {
          title: 'Help Center - Planbook Support'
        }
      },
      {
        path: '/help/terms',
        component: () => import('@/components/terms/Terms.vue'),
        alias: [
          '/help/terms.html'
        ],
        meta: {
          title: 'Terms of Service - Planbook'
        }
      },
      {
        path: '/help/privacy',
        component: () => import('@/components/privacy/Privacy.vue'),
        alias: [
          '/help/privacy.html'
        ],
        meta: {
          title: 'Privacy Policy - Planbook'
        }
      },
      {
        path: '/about',
        component: () => import('@/components/about/About.vue'),
        meta: {
          title: 'About Us - Planbook Company Information'
        }
      },
      {
        path: '/careers',
        component: () => import('@/views/pages/Careers.vue'),
        children: [
          {
            path: '/',
            component: () => import('@/components/careers/Landing.vue'),
            meta: {
              title: 'Careers - Join the Planbook Team'
            }
          }
          // {
          //   path: 'director',
          //   component: () => import('@/components/careers/Position1.vue')
          // },
          // {
          //   path: 'specialist',
          //   component: () => import('@/components/careers/Position2.vue')
          // },
          // {
          //   path: 'software-developer-full-stack',
          //   component: () => import('@/components/careers/Position3.vue')
          // },
          // {
          //   path: 'software-developer-mobile-apps',
          //   component: () => import('@/components/careers/Position4.vue')
          // }
        ]
      }
      // {
      //   path: '/careers-ph',
      //   component: () => import('@/views/pages/CareersPH.vue'),
      //   children: [
      //     {
      //       path: '/',
      //       component: () => import('@/components/careersph/Landing.vue')
      //     },
      //     {
      //       path: 'software-engineer',
      //       component: () => import('@/components/careersph/Position1.vue')
      //     },
      //     {
      //       path: 'software-quality-engineer',
      //       component: () => import('@/components/careersph/Position2.vue')
      //     }
      //   ]
      // }

    ]
  },
  {
    path: '/planbook.html',
    alias: [
      '/planbook'
    ],
    meta: {
      title: 'Planbook Login - Access Your Lesson Planner'
    },
    beforeEnter(to) {
      const query = new URLSearchParams(CommonUtils.sanitizeQuery(to.query)).toString();
      const hostname = window.location.hostname;
      let baseUrl = 'https://app.planbook.com';
      if (hostname === 'test-welcome.planbook.com' || hostname === 'test.planbook.com') {
        baseUrl = 'https://test-app.planbook.com';
      } else if (hostname === 'staging-welcome.planbook.com' || hostname === 'staging.planbook.com') {
        baseUrl = 'https://staging-app.planbook.com';
      } else if (hostname === 'localhost') {
        baseUrl = 'http://localhost:8090';
      }
      const lastSegment = to.path.split('/').filter(Boolean).pop() || 'planbook.html';
      window.location.href = `${baseUrl}/${lastSegment}${query ? '?' + query : ''}`;
    }
  },
  {
    path: '/payinvoice.html',
    alias: [
      '/payinvoice'
    ],
    meta: {
      title: 'Pay Invoice - Planbook Payment Portal'
    },
    beforeEnter(to) {
      const query = new URLSearchParams(CommonUtils.sanitizeQuery(to.query)).toString();
      const hostname = window.location.hostname;
      let baseUrl = 'https://invoice.planbook.com';
      if (hostname === 'test-welcome.planbook.com' || hostname === 'test.planbook.com') {
        baseUrl = 'https://test-invoice.planbook.com';
      } else if (hostname === 'staging-welcome.planbook.com' || hostname === 'staging.planbook.com') {
        baseUrl = 'https://staging-invoice.planbook.com';
      } else if (hostname === 'debug-welcome.planbook.com') {
        baseUrl = 'https://debug-api.planbook.com/payinvoice.html';
      } else if (hostname === 'localhost') {
        baseUrl = 'http://localhost:8080/payinvoice.html';
      }
      window.location.href = `${baseUrl}${query ? '?' + query : ''}`;
    }
  },
  {
    path: '/renewsubscription.html',
    meta: {
      title: 'Renew Subscription - Planbook Membership Renewal'
    },
    beforeEnter(to) {
      const query = new URLSearchParams(CommonUtils.sanitizeQuery(to.query)).toString();
      const hostname = window.location.hostname;
      let baseUrl = 'https://subscription.planbook.com';
      if (hostname === 'test-welcome.planbook.com' || hostname === 'test.planbook.com') {
        baseUrl = 'https://test-subscription.planbook.com';
      } else if (hostname === 'staging-welcome.planbook.com' || hostname === 'staging.planbook.com') {
        baseUrl = 'https://staging-subscription.planbook.com';
      } else if (hostname === 'debug-welcome.planbook.com') {
        baseUrl = 'https://debug-api.planbook.com/renewsubscription.html';
      } else if (hostname === 'localhost') {
        baseUrl = 'http://localhost:8080/renewsubscription.html';
      }
      window.location.href = `${baseUrl}${query ? '?' + query : ''}`;
    }
  },
  {
    path: '/support.html',
    meta: {
      title: 'Support - Planbook Help and Customer Service'
    },
    beforeEnter(to) {
      const query = new URLSearchParams(CommonUtils.sanitizeQuery(to.query)).toString();
      const hostname = window.location.hostname;
      let baseUrl = 'https://support.planbook.com';
      if (hostname === 'test-welcome.planbook.com' || hostname === 'test.planbook.com') {
        baseUrl = 'https://test-support.planbook.com';
      } else if (hostname === 'staging-welcome.planbook.com' || hostname === 'staging.planbook.com') {
        baseUrl = 'https://staging-support.planbook.com';
      } else if (hostname === 'debug-welcome.planbook.com') {
        baseUrl = 'https://debug-api.planbook.com/support.html';
      } else if (hostname === 'localhost') {
        baseUrl = 'http://localhost:8080/support.html';
      }
      window.location.href = `${baseUrl}${query ? '?' + query : ''}`;
    }
  },
  {
    path: '*',
    component: () => import('@/views/pages/NotFound.vue'),
    meta: {
      title: 'Page Not Found - Planbook'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
})

function smoothScrollTo(top: number, duration: number): void {
  const start = window.scrollY;
  const distance = top - start;
  let startTime: number | null = null;

  function animation(currentTime: number): void {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, start, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t: number, b: number, c: number, d: number): number {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animation);
}

router.afterEach((to) => {
  if (to.meta?.title) {
    document.title = to.meta.title as string;
  } else {
    // Fallback to default title if no meta title is defined
    document.title = 'Planbook - The Leader in Lesson Planning';
  }

  smoothScrollTo(0, 600); // Scroll to top when changing routes
});

export default router
